import QuickNavItem from './QuickNavItem';

export default QuickNavItem;
export { QuickNavItem };
